export default __webpack_public_path__ + "static/media/MO.c6c6d566.ico";